// Progressive enhancement for the contact form: submit via fetch so the page
// doesn't reload, show an inline status, and reset the spam-protection widget
// between attempts. Without JS the form posts normally and the server redirects
// with ?sent=1|0.
const form = document.querySelector<HTMLFormElement>(".contact-form");

interface CaptchaApi {
  reset: () => void;
}
declare global {
  interface Window {
    turnstile?: CaptchaApi;
    grecaptcha?: CaptchaApi;
  }
}

function statusEl(f: HTMLFormElement): HTMLParagraphElement {
  let el = f.querySelector<HTMLParagraphElement>("[data-form-status]");
  if (!el) {
    el = document.createElement("p");
    el.setAttribute("data-form-status", "");
    const kicker = f.querySelector(".kicker");
    if (kicker) kicker.after(el);
    else f.prepend(el);
  }
  return el;
}

function showStatus(
  f: HTMLFormElement,
  kind: "ok" | "error",
  msg?: string,
): void {
  const el = statusEl(f);
  el.className = kind === "ok" ? "form-ok" : "form-error";
  const fallback = kind === "ok" ? f.dataset.ok : f.dataset.error;
  el.textContent = msg || fallback || "";
  el.scrollIntoView({ block: "nearest", behavior: "smooth" });
}

function resetCaptcha(f: HTMLFormElement): void {
  const provider = f.dataset.captcha;
  try {
    if (provider === "turnstile") window.turnstile?.reset();
    else if (provider === "recaptcha") window.grecaptcha?.reset();
    else if (provider === "altcha") {
      const w = f.querySelector<HTMLElement & { reset?: () => void }>(
        "altcha-widget",
      );
      w?.reset?.();
    }
  } catch {
    /* widget not ready — ignore */
  }
}

if (form) {
  const btn = form.querySelector<HTMLButtonElement>('button[type="submit"]');
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    form.querySelector("[data-form-status]")?.remove();
    if (!form.reportValidity()) return;

    const data = new URLSearchParams();
    new FormData(form).forEach((v, k) => data.append(k, String(v)));

    if (btn) btn.disabled = true;
    try {
      const res = await fetch(form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        body: data.toString(),
      });
      const json = (await res.json().catch(() => ({ ok: res.ok }))) as {
        ok?: boolean;
        error?: string;
      };
      if (res.ok && json.ok) {
        form.reset();
        form.classList.add("is-sent");
        showStatus(form, "ok");
      } else {
        showStatus(form, "error", json.error);
      }
    } catch {
      showStatus(form, "error");
    } finally {
      if (btn) btn.disabled = false;
      resetCaptcha(form);
    }
  });
}
